define("TavanoTeam.CSExtensions.MyAccount.EntryPoint", ["TavanoTeam.CSExtensions.CSCertCaptureExt", "TavanoTeam.CapSciExtensions.CSSearchSpringExt.Footer", "Profile.Model", "SC.Configuration", "jQuery"], function (
  CSCertCapture,
  SearchSpringFooterExt,
  ProfileModel,

  Configuration,
  jQuery
) {
  "use strict";

  return {
    mountToApp: function mountToApp(container) {
      if (Configuration.get("certCapture.enable")) {
        CSCertCapture.loadCertCapture(container);
      }

      if (Configuration.get("searchSpring.enable")) {
        SearchSpringFooterExt.loadSearchSpringFooter(container);
      }
    }
  };
});
